export const formatDateString = ({ locale, dateString, options }) => {
  const dateTimeFormatter = new Intl.DateTimeFormat(locale, options)

  return dateTimeFormatter.format(new Date(dateString))
}
